export const LOAD_CATALOG_COURSE_DETAILS = 'LOAD_CATALOG_COURSE_DETAILS';
export const SET_LOAD_CATALOG_COURSE_DETAILS_STATUS = 'SET_LOAD_CATALOG_COURSE_DETAILS_STATUS';